import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Meta, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Contacto } from 'src/app/interfaces/contacto';
import { ContactoService } from 'src/app/services/contacto/contacto.service';
import { environment } from 'src/environments/environment';
import intlTelInput from 'intl-tel-input';


const correoRegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  captchaIsLoaded: boolean;
  captchaSuccess: boolean;
  captchaIsExpired: boolean;
  captchaResponse: string;
  calveSitio: string;
  lang: string;
  telefonoInput: any;
  formCont: FormGroup;
  formData: FormData;
  paisCodigo: number;
  pais: string;
  enviandoForm: boolean;
  envioCorreo: boolean;
  mostrarMensaje: boolean;
  mensajeExito: string;
  mensajeError: string;

  constructor(private title: Title, private meta: Meta, private formBuilder: FormBuilder, private cdr: ChangeDetectorRef,
        private contactoService: ContactoService, private router: Router) {

    this.agregarMetaData();
    this.lang = "es";
    this.captchaIsLoaded = false;
    this.captchaSuccess = false;
    this.captchaIsExpired = false;
    this.calveSitio = environment.siteKey;

    this.paisCodigo = 52;
    this.pais = 'Mexico (México)';
    this.mostrarMensaje = false;
   }

  ngOnInit(): void {
    this.formCont = this.formBuilder.group({
      nombre:['', Validators.required],
      apellidos: ['', Validators.required],
      correo: ['', [Validators.required, Validators.pattern(correoRegExp)]],
      telefono: ['', [Validators.required, Validators.pattern(/^([0-9])*$/),
                    Validators.minLength(10), Validators.maxLength(12)]],
      mensaje: ['', Validators.required],
      recaptcha: ['', Validators.required]
    });
      // Inicialización de la librería intl-tel-input
      const input = document.querySelector("#telefono") as HTMLInputElement;
      console.log('input', input)
      this.telefonoInput = intlTelInput(input, {
        preferredCountries: ['mx'],
        separateDialCode: true,
        utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js' // URL al script de utilidades
      });
  
      // Escucha el evento countrychange
      this.telefonoInput.node.addEventListener("countrychange", (event: any) => {
        this.obtenerCodigoPais(event);
        console.log('event', event)
      });
  }

  private agregarMetaData(): void {
    this.title.setTitle('Contactanos');
    this.meta.updateTag({name: "description", content: "¿Tienes alguna duda? Haznos saber en cómo podemos ayudarte."});//falta descripcion e imagen para mostrar en open graph
    this.meta.updateTag({name: "keywords", content: "contacto, candidatos, empresas, dudas"});
    this.meta.updateTag({name: "robots", content: "noodp"});
    this.meta.updateTag({property: "og:title", content: "Contactanos"});
    this.meta.updateTag({property: "og:description", content: "¿Tienes alguna duda? Haznos saber en cómo podemos ayudarte."});
    this.meta.updateTag({property: "og:url", content: environment.baseTG});
    this.meta.updateTag({property: "og:site_name", content: "TG Empleos"});
    this.meta.updateTag({property: "og:locale", content: "es_ES"});
    this.meta.updateTag({property: "og:type", content: "website"});
    this.meta.updateTag({property: "og:image", content: environment.baseAssets+"/img/sitio-web-de-tg.jpg"});
    this.meta.updateTag({name: "twitter:title", content: "Contactanos"});
    this.meta.updateTag({name: "twitter:description", content:"¿Tienes alguna duda? Haznos saber en cómo podemos ayudarte."});
    this.meta.updateTag({name: "twitter:site", content: "@tecgurusnet"});
    this.meta.updateTag({name: "twitter:image", content: environment.baseAssets+"/img/sitio-web-de-tg.jpg"});
    this.meta.updateTag({name: "twitter:creator", content: "@tecgurusnet"});
    this.meta.updateTag({name: "twitter:card", content: "summary"});
  }

  enviarContacto(): void{
    this.mostrarMensaje = true;
    if (this.formCont.valid && this.captchaSuccess) {
        const contacto: Contacto = {
            nombre: this.formCont.value.nombre,
            apellidos: this.formCont.value.apellidos,
            correo: this.formCont.value.correo,
            codigoPais: this.telefonoInput.getSelectedCountryData().dialCode,
            telefono: this.formCont.value.telefono,
            mensaje: this.formCont.value.mensaje
        };
        console.log('contacto', contacto)
        this.contactoService.enviarContacto(contacto).pipe(
            catchError(error => {
                let mensajeError = '';
                if (error.status === 0) {
                    mensajeError = 'Error: se ha producido un error: '+ error.error + '/n'
                    mensajeError += `Http error: ${error.message}`;
                    console.error('se ha producido un error:', error.error);
                }else{
                    mensajeError = `Error (código ${error.error.statusCode}): mensaje de error: ${error.error.messageError}.\n`;
                    mensajeError += `Http error: ${error.message}`;
                    console.error(`Error en el API ${error.status}, cuerpo: `, error.error);
                }
                this.handleReset();
                this.handleLoad();
                this.mensajeError = mensajeError;
                this.reiniciarMensajes();
                return throwError(mensajeError);
            })
        ).subscribe(result => {
            this.envioCorreo = true;
            if(result.success){
                this.mostrarMensaje = false;
                this.mensajeExito = 'Éxito Se ha enviado el correo correctamente en un momento se comunican con usted.';
                this.reiniciarMensajes();
                this.ngOnInit();
            }else{
                this.mensajeExito = 'Error se ha producido un error al mandar el correo, intentelo más tarde.';
                console.error('Error enviar correo: ', result.messageError);
            }
            this.handleReset();
            this.handleLoad();
        });
    }else{
      if(!this.formCont.value.recaptcha && !this.formCont.controls.nombre.errors && !this.formCont.controls.apellidos.errors &&
        !this.formCont.controls.correo.errors && !this.formCont.controls.telefono.errors && !this.formCont.controls.mensaje.errors){
            this.mensajeError = "Tienes que llenar el captcha";
            this.enviandoForm = true;
      }else{
        this.scrollToElement('arriba');
      }
    }
    this.reiniciarMensajes();
  }

  obtenerCodigoPais(event: any): void {
    const paisSeleccionado = this.telefonoInput.getSelectedCountryData();
    console.log("Código de país:", paisSeleccionado.dialCode);
    console.log("Nombre de país:", paisSeleccionado.name);
    // Aquí puedes realizar cualquier acción que necesites con el código de país seleccionado
  }

  reiniciarMensajes(){
    setTimeout(() => {
        this.enviandoForm = false;
        this.mostrarMensaje = false;
        this.mensajeError = "" as string;
        this.mensajeExito = "" as string;
    }, 3000);
  }

  scrollToElement(element: string): void {
    document.getElementById(element).scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
  }

  handleError(): void {
    this.cdr.detectChanges();
  }

  handleReset(): void {
    this.captchaSuccess = false;
    this.captchaResponse = undefined;
    this.captchaIsExpired = false;
    this.cdr.detectChanges();
  }

  handleLoad(): void {
    this.captchaIsLoaded = true;
    this.captchaIsExpired = false;
    this.cdr.detectChanges();
  }

  handleExpire(): void {
    this.captchaSuccess = false;
    this.captchaIsExpired = true;
    this.cdr.detectChanges();
  }

  handleSuccess(captchaResponse: string): void {
    this.captchaSuccess = true;
    this.captchaResponse = captchaResponse;
    this.captchaIsExpired = false;
  }
}
